﻿export function loadGoogleMaps(opts = {}) {
    const id = 'gsdk'

    return new Promise(resolve => {
        if (document.getElementById(id)) {
            return resolve(true)
        }

        window.googleapiloaded = resolve;

        opts.callback = "googleapiloaded"; 
        const optionsQuery = Object.keys(opts)
            .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(opts[k])}`)
            .join('&');
        const url = `https://maps.googleapis.com/maps/api/js?${optionsQuery}`;
        const script = document.createElement('script');

        script.setAttribute('src', url);
        script.setAttribute('id', id);
        script.async = true;
        document.head.appendChild(script);
    })
}